import React, { PropsWithChildren, useEffect, useState } from 'react';
import { AuthProvider as OidcAuthProvider, AuthProviderProps } from 'react-oidc-context';
import { getAppSettings, AppSettings } from '../utils/appsettings';

interface AuthWrapperProps extends PropsWithChildren {}
const INTENDED_URL_KEY = 'auth_intended_url';

export const AuthProvider: React.FC<AuthWrapperProps> = ({ children }) => {
  const [oidcConfig, setOidcConfig] = useState<AuthProviderProps | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const appSettings: AppSettings = await getAppSettings();

        const config: AuthProviderProps = {
          authority: appSettings.userManager.authority,
          client_id: appSettings.userManager.client_id,
          redirect_uri: appSettings.userManager.redirect_uri,
          post_logout_redirect_uri: appSettings.userManager.post_logout_redirect_uri,
          scope: appSettings.userManager.scope,
          response_type: appSettings.userManager.response_type,
          automaticSilentRenew: appSettings.userManager.automaticSilentRenew === 'true',
          silent_redirect_uri: appSettings.userManager.silent_redirect_uri,
          loadUserInfo: true,
          onSigninCallback: () => {
          const intendedUrl = sessionStorage.getItem(INTENDED_URL_KEY);
            sessionStorage.removeItem(INTENDED_URL_KEY);
            if (intendedUrl && intendedUrl !== '/' && intendedUrl !== '/auth/callback/eam') {
              globalThis.location.replace(intendedUrl);
            } else {
              globalThis.history.replaceState({}, '', globalThis.location.pathname);
            }
          },
        };

        setOidcConfig(config);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load authentication configuration');
        console.error('Failed to initialize auth:', err);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  if (loading) {
    return <div>Loading authentication...</div>;
  }

  if (error) {
    return <div>Error loading authentication: {error}</div>;
  }

  if (!oidcConfig) {
    return <div>Authentication configuration not available</div>;
  }

  return <OidcAuthProvider {...oidcConfig}>{children}</OidcAuthProvider>;
};
